export const GET_SAVED_POLICIES_SUCCESS = 'GET_SAVED_POLICIES_SUCCESS';
export const GET_SAVED_SEARCHES_SUCCESS = 'GET_SAVED_SEARCHES_SUCCESS';
export const LOAD_SAVED_SUCCESS = 'LOAD_SAVED_SUCCESS';
export const SET_SEARCH_HEADERS = 'SET_SEARCH_HEADERS';
export const SET_SEARCH_HEADER = 'SET_SEARCH_HEADER';
export const ADD_SEARCH_HEADER = 'ADD_SEARCH_HEADER';
export const GET_FAVORITE_SEARCHES_SUCCESS = 'GET_FAVORITE_SEARCHES_SUCCESS';
export const ADD_TO_FAVORITE_SEARCH_SUCCESS = 'ADD_TO_FAVORITE_SEARCH_SUCCESS';
export const REMOVE_FROM_FAVORITE_SEARCH_SUCCESS = 'REMOVE_FROM_FAVORITE_SEARCH_SUCCESS';
